import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { NotificationService } from '@shared/services';
import { ToastActions } from './toast.actions';

export const toastError$ = createEffect(
  (actions$ = inject(Actions), notificationService = inject(NotificationService)) => {
    return actions$.pipe(
      ofType(ToastActions.error),
      map((notification) => notificationService.displayError(notification.message)),
    );
  },
  { functional: true, dispatch: false },
);

export const toastSuccess$ = createEffect(
  (actions$ = inject(Actions), notificationService = inject(NotificationService)) => {
    return actions$.pipe(
      ofType(ToastActions.success),
      map((notification) => notificationService.displaySuccess(notification.message)),
    );
  },
  { functional: true, dispatch: false },
);

export const toastWarning$ = createEffect(
  (actions$ = inject(Actions), notificationService = inject(NotificationService)) => {
    return actions$.pipe(
      ofType(ToastActions.warning),
      map((notification) => notificationService.displayWarning(notification.message)),
    );
  },
  { functional: true, dispatch: false },
);

export const clearAll$ = createEffect(
  (actions$ = inject(Actions), notificationService = inject(NotificationService)) => {
    return actions$.pipe(
      ofType(ToastActions.clearAll),
      map(() => notificationService.clearAll()),
    );
  },
  { functional: true, dispatch: false },
);
